// extracted by mini-css-extract-plugin
export default {"properties":"Properties_properties__EWFqR","property":"Properties_property__CO-hr","icon":"Properties_icon__WWh+A","title":"Properties_title__sTYdT"};